import React, { useRef, useState, useEffect } from "react";
import { WEBSITE_NAME } from "../modals/Constants";
import { Link, useNavigate } from "react-router-dom";
import general from "../css/General.module.css";

function Home() {
  useEffect(() => {
    // Add the TradingView widget script dynamically
    const script = document.createElement('script');
    script.src = "https://s3.tradingview.com/tv.js";
    script.async = true;
    script.onload = () => {
      new window.TradingView.widget({
        "width": "100%",    // Width of the widget
        "height": "500",    // Height of the widget
        "symbol": "BTCUSD", // Symbol for Bitcoin (can change based on your needs)
        "interval": "D",    // Time interval for the chart (e.g., "D" for daily)
        "timezone": "Etc/UTC", // Timezone of the chart
        "theme": "dark",    // Theme of the chart
        "style": "1",       // Style of the chart (1: bars, 2: candles, etc.)
        "container_id": "tradingview-widget", // ID of the container where the chart will be rendered
      });
    };
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script); // Clean up when component is unmounted
    };
  }, []);


  return (
    <div
      className={[
        general.appContents
      ].join(" ")}
    >
      <div className="w-100 row-view sb-view pd-15 resp-topbar">
        <p className="ft-sz-28 ft-wgt-500 cl-white">{WEBSITE_NAME}</p>

        <div className="row-view ft-sz-18">
          <Link
            className="d-block txt-deco-n pd-15-20 cl-white bg-selected"
            to={"/login"}
          >Sign In</Link>
          <Link
            className="d-block txt-deco-n pd-15-20 cl-white bg-custom-1"
            to={"/register"}
          >Sign Up</Link>
        </div>
      </div>

      <div className="w-100 col-view v-center pd-80-15 bg-custom-1">
        <p className="txt-a-center ft-sz-28 ft-wgt-500 cl-white">We have differents type of predict</p>
        <p className="txt-a-center ft-sz-16 cl-l-white-2 mg-t-15">There is a third type of prediction, which is different from the previous two. In the<br></br>example, we need to have some sort of understanding.</p>

        <div className="resp-w-90  g-v-6 mg-t-25">
          <div className="col-view v-center pd-30-15 cl-white br-5 bg-primary">
            <i className='bx bxs-like ft-sz-28 cl-selected'></i>
            <span className="txt-a-center ft-sz-16 mg-t-10">Easy Interface</span>
          </div>

          <div className="col-view v-center pd-30-15 cl-white br-5 bg-primary">
            <i className='bx bxs-objects-vertical-center ft-sz-28 cl-selected' ></i>
            <span className="txt-a-center ft-sz-16 mg-t-10">Call Put options</span>
          </div>

          <div className="col-view v-center pd-30-15 cl-white br-5 bg-primary">
            <i className='bx bxs-bolt-circle ft-sz-28 cl-selected' ></i>
            <span className="txt-a-center ft-sz-16 mg-t-10">Turbo speed</span>
          </div>

          <div className="col-view v-center pd-30-15 cl-white br-5 bg-primary">
            <i className='bx bxs-right-top-arrow-circle ft-sz-28 cl-selected' ></i>
            <span className="txt-a-center ft-sz-16 mg-t-10">Demo Trade</span>
          </div>

          <div className="col-view v-center pd-30-15 cl-white br-5 bg-primary">
            <i className='bx bxs-pie-chart-alt-2 ft-sz-28 cl-selected' ></i>
            <span className="txt-a-center ft-sz-16 mg-t-10">Auto Trade</span>
          </div>

          <div className="col-view v-center pd-30-15 cl-white br-5 bg-primary">
            <i className='bx bxs-check-shield ft-sz-28 cl-selected' ></i>
            <span className="txt-a-center ft-sz-16 mg-t-10">Fast & Secured</span>
          </div>
        </div>
      </div>

      <div className="w-100 col-view v-center pd-80-15">
        <p className="ft-sz-28 ft-wgt-500 cl-white">Make a Quick Trade</p>
        <p className="txt-a-center ft-sz-16 cl-l-white-2 mg-t-15">Unfortunately, the idea that this kind of trading is some kind of "get-rich-quick"<br></br> scheme persists. Some people day trade without sufficient knowledg</p>

        <div className="row-view ft-sz-18 mg-t-15">
          <div className="pd-15 cl-white bg-selected">I'm a Beginner</div>
          <div className="pd-15 cl-white bg-custom-1">I'm an Expert</div>
        </div>

        <div
          id="tradingview-widget"
          className="show-chart-view mg-t-30"></div>

      </div>

      <div className="w-100 col-view v-center pd-80-15 bg-custom-1">
        <p className="txt-a-center ft-sz-28 ft-wgt-500 cl-white">Why Trade with Us</p>
        <p className="txt-a-center ft-sz-16 cl-l-white-2 mg-t-15">Basic economic concept involving the buying and selling of goods and services, with<br></br> compensation paid by a buyer to a seller</p>

        <div className="resp-w-90 g-v-3 mg-t-25">
          <div className="col-view v-center pd-50-15 cl-white br-5 bg-primary">
            <i className='bx bxs-like ft-sz-28 cl-selected'></i>
            <span className="ff-secondary ft-sz-20 mg-t-10">Best Payout</span>
            <span className="txt-a-center ft-sz-16 cl-l-white-2 mg-t-10">Get the highest payouts with fast,<br></br>transparent payments and no hidden fees.</span>
          </div>

          <div className="col-view v-center pd-50-15 cl-white br-5 bg-primary">
            <i className='bx bxs-objects-vertical-center ft-sz-28 cl-selected' ></i>
            <span className="ff-secondary ft-sz-20 mg-t-10">Cashback Options</span>
            <span className="txt-a-center ft-sz-16 cl-l-white-2 mg-t-10">Enjoy flexible cashback options with great rewards<br></br>and easy access to your savings.</span>
          </div>

          <div className="col-view v-center pd-50-15 cl-white br-5 bg-primary">
            <i className='bx bxs-bolt-circle ft-sz-28 cl-selected' ></i>
            <span className="ff-secondary ft-sz-18 mg-t-10">Safety & Security</span>
            <span className="txt-a-center ft-sz-16 cl-l-white-2 mg-t-10">Your data is protected with the highest security<br></br>standards for a safe experience.</span>
          </div>

          <div className="col-view v-center pd-50-15 cl-white br-5 bg-primary">
            <i className='bx bxs-right-top-arrow-circle ft-sz-28 cl-selected' ></i>
            <span className="ff-secondary ft-sz-18 mg-t-10">Easy to Trade</span>
            <span className="txt-a-center ft-sz-16 cl-l-white-2 mg-t-10">Enjoy a simple, user-friendly platform for<br></br>hassle-free trading.</span>
          </div>

          <div className="col-view v-center pd-50-15 cl-white br-5 bg-primary">
            <i className='bx bxs-pie-chart-alt-2 ft-sz-28 cl-selected' ></i>
            <span className="ff-secondary ft-sz-18 mg-t-10">Quick Fund Access</span>
            <span className="txt-a-center ft-sz-16 cl-l-white-2 mg-t-10">Withdraw your funds swiftly with fast and<br></br>easy access anytime.</span>
          </div>

          <div className="col-view v-center pd-15 cl-white br-5 bg-primary">
            <i className='bx bxs-check-shield ft-sz-28 cl-selected' ></i>
            <span className="ff-secondary ft-sz-18 mg-t-10">24x7 Help</span>
            <span className="txt-a-center ft-sz-16 cl-l-white-2 mg-t-10">Get round-the-clock support whenever<br></br>you need assistance.</span>
          </div>
        </div>
      </div>

    </div>
  );
}

export default Home;